module.exports = __webpack_public_path__ + "img/xy4@2x.e8b061f7.png";